import type * as ngRouter from '@uirouter/angularjs';

export interface RouterContext {
  toState: any;
  toParams: any;
  fromState: any;
  fromParams: any;
}

export default class NavigationHistoryService {
  public currentContext: RouterContext;

  static $inject = ['$transitions'];

  constructor(private $transitions: ngRouter.Transition) {}

  init() {
    this.$transitions.onSuccess({}, (trans) => {
      this.currentContext = {
        toState: trans.to(),
        toParams: trans.params('to'),
        fromState: trans.from(),
        fromParams: trans.params('from'),
      };
    });
  }

  getCurrentContext(): RouterContext {
    return this.currentContext;
  }
}
